import { EmptyState, ErrorBoundary, FlexBox } from '@dixa/lib-shared-habla';
import { Navigate, Route, Routes } from 'react-router-dom';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useServerStorage } from 'utils/useServerStorage';

import { TvDashboardView } from './tvDashboard.view';
import { TvLegacyDashboardView } from './views/legacy';
import { TvOrganizationDashboardView } from './views/organization';
import { TvQueueDashboardView } from './views/queue';

export const TvDashboardRoutes = (): JSX.Element => {
  const flags = useFeatureFlag(['new-live-dashboard']);
  const storage = useServerStorage('user');
  const { prefersNewDashboard = true } = storage.data.dashboard ?? {};

  return (
    <Routes>
      <Route
        path="*"
        element={
          <ErrorBoundary
            fallback={
              <FlexBox
                height="100%"
                alignItems="center"
                justifyContent="center"
              >
                <EmptyState
                  title="Something went wrong"
                  description="The dashboard is currently unavailable due to an unexpected
            error. Our team has been notified and is looking into the
            issue."
                  icon="exclamation"
                  iconColor="red.500"
                  buttonProps={{
                    variant: 'primary',
                    children: 'Try reloading',
                    onClick: () => window.location.reload(),
                  }}
                />
              </FlexBox>
            }
          >
            <TvDashboardView />
          </ErrorBoundary>
        }
      >
        <Route index element={<Navigate to="organization" replace />} />

        {flags.newLiveDashboard ? (
          <>
            <Route
              path=":queueId"
              element={
                prefersNewDashboard ? (
                  <TvQueueDashboardView />
                ) : (
                  <TvLegacyDashboardView />
                )
              }
            />
            <Route
              path="organization"
              element={<TvOrganizationDashboardView />}
            />
          </>
        ) : (
          <Route path=":queueId" element={<TvLegacyDashboardView />} />
        )}
      </Route>
    </Routes>
  );
};
